<template>
  <v-list dense class="pt-0" width="335px">
    <v-btn-toggle dense>
      <v-btn
        @click="$emit('moveUp')"
        v-tooltip="{
          content:
            'Move Up <kbd>Ctrl</kbd><span> + </span><kbd>Alt</kbd><span> + </span><kbd>↑</kbd>',
          html: true
        }"
      >
        <oh-v-icon name="md-moveup-round"></oh-v-icon>
      </v-btn>
      <v-btn
        @click="$emit('moveDown')"
        v-tooltip="{
          content:
            'Move Down <kbd>Ctrl</kbd><span> + </span><kbd>Alt</kbd><span> + </span><kbd>↓</kbd>',
          html: true
        }"
      >
        <oh-v-icon name="md-movedown-round"></oh-v-icon>
      </v-btn>
      <v-btn
        @click="$emit('indent', {})"
        v-tooltip="{ content: 'Nest (indent) <kbd>Tab</kbd>', html: true }"
      >
        <oh-v-icon name="md-keyboardtab"></oh-v-icon>
      </v-btn>
      <v-btn
        @click="$emit('deindent')"
        v-tooltip="{
          content: 'Pop-out (dendent) <kbd>Shift</kbd><span> + </span><kbd>Tab</kbd>',
          html: true
        }"
      >
        <oh-v-icon name="md-keyboardtab" style="transform: scale(-1);"></oh-v-icon>
      </v-btn>
      <v-btn
        @click="$emit('addNewLineAbove')"
        v-tooltip="{
          content: 'Add new line above',
          html: false
        }"
      >
        <oh-v-icon name="md-add" scale="0.7" style="margin-right: -5px;"></oh-v-icon>
        <oh-v-icon name="md-turnright" style="margin-top: -5px;"></oh-v-icon>
      </v-btn>
      <v-btn
        @click="$emit('addNewLineBelow')"
        v-tooltip="{
          content: 'Add new line below',
          html: false
        }"
      >
        <oh-v-icon name="md-add" scale="0.7" style="margin-right: -5px;"></oh-v-icon>
        <oh-v-icon name="md-turnright" flip="vertical" style="margin-top: 5px;"></oh-v-icon>
      </v-btn>
    </v-btn-toggle>
    <!-- <v-row no-gutters> -->
    <!-- <v-btn
        text
        class="col"
        :class="{ 'v-btn--active': page.flair.check }"
        :color="page.flair.check ? 'primary' : ''"
        @click="$emit('updateFlair', { flair: 'check', value: !page.flair.check })"
      >
        <v-icon>check</v-icon>
      </v-btn>

      <v-btn
        text
        class="col"
        :class="{ 'v-btn--active': enabledFlair.includes('flag') }"
        :color="enabledFlair.includes('flag') ? 'primary' : ''"
        @click="$emit('updateFlair', { flair: 'flag', enableState: 'toggle' })"
      >
        <v-icon>bookmark_outline</v-icon>
      </v-btn>

      <v-btn
        text
        class="col"
        :class="{ 'v-btn--active': enabledFlair.includes('featured') }"
        :color="enabledFlair.includes('featured') ? 'primary' : ''"
        @click="$emit('updateFlair', { flair: 'featured', enableState: 'toggle' })"
      >
        <v-icon>fit_screen</v-icon>
      </v-btn>
      <v-btn
        text
        class="col"
        :class="{ 'v-btn--active': enabledFlair.includes('cardify') }"
        :color="enabledFlair.includes('cardify') ? 'primary' : ''"
        @click="$emit('updateFlair', { flair: 'cardify', enableState: 'toggle' })"
      >
        <v-icon>style</v-icon>
      </v-btn> -->
    <v-divider></v-divider>
    <v-list-item @click="$emit('open')">
      <v-list-item-icon>
        <v-icon class="blue rounded-circle" dark style="transform: rotate(90deg);"
          >arrow_circle_up</v-icon
        >
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title> Open </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item @click="$emit('openToSide')">
      <v-list-item-icon>
        <oh-v-icon
          scale="1.2"
          name="ri-layout-column-fill"
          class="blue rounded-circle pa-1 white--text"
        >
        </oh-v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title> Open to the Side </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item @click="showAddModal = true" v-if="showSendToTeammate">
      <v-list-item-icon>
        <oh-v-icon scale="1.2" name="bi-send-plus" class="blue rounded-circle pa-1 white--text">
        </oh-v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title> Send to Teammate </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <add-to-teammate-modal
      v-if="showAddModal"
      v-model="showAddModal"
      @select="showAddModal = false"
      :page="page"
    ></add-to-teammate-modal>
    <v-list-item @click="$emit('addToMyPanel')" v-if="showAddToMyPanel">
      <v-list-item-icon class="pink rounded-circle">
        <v-icon small class="pl-1" dark>add</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Add to My Panel </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item @click="$emit('archive')" v-if="showArchive">
      <v-list-item-icon class="green rounded-circle">
        <v-icon small class="pl-1" dark>move_to_inbox</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Archive </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item @click="$emit('deleteNote')" v-if="showDelete">
      <v-list-item-icon class="red rounded-circle">
        <v-icon small dark class="pl-1">delete</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title> Delete </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <!-- <v-list-group sub-group v-if="showMove">
      <template v-slot:activator>
        <v-list-item-title>Move</v-list-item-title>
      </template>

      <v-list-item @click="$emit('moveTo')">
        <v-list-item-icon>
          <v-icon small>exit_to_app</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Move To... </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item @click="$emit('indent')">
        <v-list-item-icon>
          <v-icon small>format_indent_increase</v-icon>
        </v-list-item-icon>
        <v-list-item-title> Nest (indent) </v-list-item-title>
        <v-list-item-title>
          <kbd>Tab</kbd>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="$emit('deindent')">
        <v-list-item-icon>
          <v-icon small>format_indent_decrease</v-icon>
        </v-list-item-icon>
        <v-list-item-title> Pop Out (de-indent) </v-list-item-title>
        <v-list-item-title>
          <kbd>Shift</kbd>
          <span> + </span>
          <kbd>Tab</kbd>
        </v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item @click="$emit('addNewLineAbove')">
        <v-list-item-icon>
          <v-icon small style="transform: scale(-1);">keyboard_return</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Add New Above </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="$emit('addNewLineBelow')">
        <v-list-item-icon>
          <v-icon small style="transform: scaleX(-1);">keyboard_return</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Add New Below </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item @click="$emit('moveUp')">
        <v-list-item-icon>
          <v-icon small>arrow_upward</v-icon>
        </v-list-item-icon>
        <v-list-item-title> Move Up </v-list-item-title>
        <v-list-item-title>
          <kbd>Ctrl</kbd>
          <span> + </span>
          <kbd>Alt</kbd>
          <span> + </span>
          <kbd><v-icon x-small color="white">keyboard_arrow_up</v-icon></kbd>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="$emit('moveDown')">
        <v-list-item-icon>
          <v-icon small>arrow_downward</v-icon>
        </v-list-item-icon>
        <v-list-item-title> Move Down </v-list-item-title>
        <v-list-item-title>
          <kbd>Ctrl</kbd>
          <span> + </span>
          <kbd>Alt</kbd>
          <span> + </span>
          <kbd><v-icon x-small color="white">keyboard_arrow_down</v-icon></kbd>
        </v-list-item-title>
      </v-list-item>
    </v-list-group> -->
    <v-list-group sub-group>
      <template v-slot:activator>
        <v-list-item-title>Flair</v-list-item-title>
      </template>
      <!-- <v-list-item @click="$emit('updateFlair', { flair: 'cardify', enableState: 'toggle' })">
        <v-list-item-action>
          <v-checkbox
            @click.stop="$emit('updateFlair', { flair: 'cardify', enableState: 'toggle' })"
            :input-value="enabledFlair.includes('cardify')"
            color="primary"
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Cardify
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="$emit('updateFlair', { flair: 'section', enableState: 'toggle' })">
        <v-list-item-action>
          <v-checkbox
            @click.stop="$emit('updateFlair', { flair: 'section', enableState: 'toggle' })"
            :input-value="enabledFlair.includes('section')"
            color="primary"
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Sectionify
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <v-list-item @click="$emit('updateFlair', { flair: 'rating', enableState: 'toggle' })">
        <v-list-item-action>
          <v-checkbox
            @click.stop="$emit('updateFlair', { flair: 'rating', enableState: 'toggle' })"
            :input-value="enabledFlair.includes('rating')"
            color="primary"
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Rating
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action @click.stop>
          <v-rating
            :disabled="false"
            @click.stop
            :value="page.flair.rating || 0"
            @input="
              $emit('updateFlair', { flair: 'rating', value: $event, enableState: 'enabled' })
            "
            small
          ></v-rating>
        </v-list-item-action>
      </v-list-item>
      <v-list-item @click="$emit('updateFlair', { flair: 'progress', enableState: 'toggle' })">
        <v-list-item-action>
          <v-checkbox
            @click.stop="$emit('updateFlair', { flair: 'progress', enableState: 'toggle' })"
            :input-value="enabledFlair.includes('progress')"
            color="primary"
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Progress
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action @click.stop>
          <v-slider
            :value="page.flair.progress"
            @input="
              $emit('updateFlair', {
                flair: 'progress',
                value: $event,
                enableState: 'enabled'
              })
            "
            @mousedown.stop
            style="min-width: 150px;"
            class="pb-1"
            :color="
              page.flair.progress < 40 ? 'amber' : page.flair.progress < 70 ? 'orange' : 'green'
            "
            hide-details
            dense
            track-color="grey"
            step="10"
          ></v-slider>
        </v-list-item-action>
      </v-list-item>
      <v-list-item @click="$emit('updateFlair', { flair: 'likelyhood', enableState: 'toggle' })">
        <v-list-item-action>
          <v-checkbox
            @click.stop="$emit('updateFlair', { flair: 'likelyhood', enableState: 'toggle' })"
            :input-value="enabledFlair.includes('likelyhood')"
            color="primary"
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Likelyhood
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action @click.stop>
          <likely-meter
            :value="page.flair.likelyhood"
            @input="
              $emit('updateFlair', {
                flair: 'likelyhood',
                value: $event,
                enableState: 'enabled'
              })
            "
          ></likely-meter>
        </v-list-item-action>
      </v-list-item>
    </v-list-group>
    <v-menu
      v-if="enabledFlair.includes('featured')"
      offset-x
      :close-on-content-click="false"
      max-width="300"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          block
          elevation-0
          :style="{ 'background-color': page.flair.featured || '#E8F5E9' }"
          v-on="on"
        >
        </v-btn>
      </template>
      <v-color-picker
        :swatches="swatches"
        show-swatches
        elevation="2"
        :value="page.flair.featured || '#E8F5E9'"
        @input="$emit('updateFlair', { flair: 'featured', enableState: 'enabled', value: $event })"
      ></v-color-picker>
    </v-menu>
  </v-list>
</template>

<script>
import LikelyMeter from '@/components/LikelyMeter';
import AddToTeammateModal from './AddToTeammateModal.vue';

export default {
  props: {
    page: {},
    enabledFlair: {},
    flairOnly: {},
    showAddToMyPanel: {},
    showDelete: { default: true, type: Boolean },
    showArchive: { default: true, type: Boolean },
    showSendToTeammate: { default: true, type: Boolean },
    showMove: { default: true, type: Boolean }
  },
  components: { LikelyMeter, AddToTeammateModal },
  data() {
    return {
      swatches: [
        ['EF9A9A', '#FFCDD2', '#FFEBEE'],
        ['CE93D8', '#E1BEE7', '#F3E5F5'],
        ['9FA8DA', '#C5CAE9', '#E8EAF6'],
        ['90CAF9', '#BBDEFB', '#E3F2FD'],
        ['A5D6A7', '#C8E6C9', '#E8F5E9']
      ],
      flairMenu: false,
      showAddModal: false
    };
  },
  computed: {
    toggle_multiple: {
      get() {},
      set(v) {
        console.log(v);
      }
    }
  }
};
</script>

<style></style>
